import { css } from '@microsoft/fast-element';
import { HighlightComponent, highlightTemplate } from './Highlight';
import styles from './Highlight.styles.scss';
export const chameleonHighlight = HighlightComponent.compose({
    baseName: 'highlight',
    template: highlightTemplate,
    styles: css `${styles}`,
});
